import { useCallback } from "react";

import useEnum from "@hooks/useEnum";

import TipoPendenciaService from '@services/TipoPendenciaService'

const useTipoPendencia = (processo) => {
    const fetch = useCallback(() => {
        if (!processo)
            return Promise.resolve({ data: [], loading: false, error: null });

        return TipoPendenciaService.listarSemPaginacao(processo)
    }, [processo]);

    const { data, loading, error } = useEnum(fetch);

    return { data, loading, error };
}

export default useTipoPendencia;